<template>
  <div
    v-if="visible"
    class="popup v-fade"
    :class="{ 'popup--compact': compact }"
    @click="hide()"
  >
    <div class="popup__flex-box">
      <div class="popup__content" @click="$event.stopPropagation()">
        <div class="popup__close">
          <a @click="hide()">
            <span class="popup__close-icon iconfont iclose" />
          </a>
        </div>
        <div v-if="title" class="popup__title-box">
          <h2 class="popup__title" v-html="title"></h2>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps<{
  title?: string
  compact?: boolean
  closeEvent?: () => void
}>()

const emit = defineEmits(['hide'])

const visible = ref(false)

onMounted(() => {
  // We're using a global event listener here instead of `@keydown`,
  // because we would have to put `@keydown` on every level of the component
  // hierarchy to handle every possible focus.
  document.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeydown)
})

function handleKeydown(keydownEvent: KeyboardEvent): void {
  if (keydownEvent.key === 'Escape') {
    hide()
  }
}

function show(): void {
  visible.value = true
}

function hide(sendEvent: boolean = true): void {
  visible.value = false
  if (sendEvent && props.closeEvent) {
    props.closeEvent()
  }
  emit('hide')
}

function isVisible(): boolean {
  return visible.value
}

defineExpose({
  show,
  hide,
  isVisible,
})
</script>
